import { Lci3Report } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { PerformersCard } from './Performers';
import { Stack } from '@mui/material';
import { ComparisonByDimensionCard } from './ComparisonByDimension';
import { memo } from 'react';
import { Subdimension } from '@features/reports/subdomains/visitation';
import { useLciAIInsights } from '@features/ai-insights';

type OptimizationProps = {
  selectedReport: Lci3Report;
  latestSalesReport?: Lci3Report;
  allReports: Lci3Report[];
  campaignName: string;
  subdimensions: Subdimension[];
};

export const Optimization = memo((props: OptimizationProps) => {
  const { rsaAiInsights } = useLciAIInsights(
    props.latestSalesReport ?? null,
    'top-bottom-performers'
  );
  const { footTrafficAiInsights } = useLciAIInsights(
    props.selectedReport,
    'top-bottom-performers'
  );
  return (
    <Stack direction="column" gap="1rem">
      <PerformersCard
        selectedReport={props.selectedReport}
        allReports={props.allReports}
        aiInsights={rsaAiInsights ?? footTrafficAiInsights}
      />

      <ComparisonByDimensionCard
        selectedReport={props.selectedReport}
        latestSalesReport={props.latestSalesReport}
        campaignName={props.campaignName}
        key={props.selectedReport.id}
        subdimensions={props.subdimensions}
      />
    </Stack>
  );
});

Optimization.displayName = 'Optimization';
